import { render, staticRenderFns } from "./FormPersonal.vue?vue&type=template&id=54b50f90&"
import script from "./FormPersonal.vue?vue&type=script&lang=js&"
export * from "./FormPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports